<template>
  <router-view></router-view>
</template>
<script>
export default {
  name: 'Confidence',
};
</script>
